import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { i18n } from "./locales/translationConfig";
import Authentication from "@supervision/vue-components/_helpers/Authentication";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "@supervision/vue-components/fonts/fonts.css";

const tokenElement = document.getElementById("DmPortal");
const token = tokenElement ? tokenElement.getAttribute("keycloakToken") : null;

const app = createApp(App).use(router).use(i18n).use(Authentication);

if (token) {
  app.config.globalProperties.$jwt.initToken(token);
}

app.config.unwrapInjectedRef = true;

app.mount("#DmPortal");

router.beforeEach((to, from, next) => {
  if (!to.meta.roles || to.meta.roles.includes("guest")) return next();
  if (!app.config.globalProperties.$jwt.hasAtLeastOneRole(to.meta.roles))
    router.push({
      name: "Unauthorized",
      params: { code: 401 },
    });
  else return next();
});
